<template>
  <v-card outlined>
    <v-dialog v-if="dialogReport" v-model="dialogReport" :overlay-opacity="0.92" persistent max-width="320" style="z-index: 9999999;">
      <v-card>
        <v-card-title>{{ statusSelected.text}}</v-card-title>
        <v-card-actions class="mx-4" v-if="!isOnMobile">
          <span>Желаете ли да направите отчета?</span>
        </v-card-actions>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogReport = false" color="warning" tile>Отказ</v-btn>
          <v-btn @click="
              dialogReport = false;
              printReport();
            " color="#1685c9" tile>ОК</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row justify="center" align="center" class="ma-1 mb-5">
      <v-spacer></v-spacer>
      <span class="title">Статус на устройството</span>
      <v-spacer></v-spacer>
      <v-btn color="error" text fab small @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-row>
    <v-row v-if="statusMessage" justify="center" class="ma-1">
      <span class="subtitle error--text">{{ statusMessage }}</span>
    </v-row>

    <v-row justify="center" class="ma-0"></v-row>
    <v-row justify="center" class="ma-0">
      <v-divider></v-divider>
    </v-row>
    <v-row class="ma-0 pa-2" align="center">
      <v-chip :x-small="isOnMobile" class="pa-0 px-5" v-for="(st, index) in status" ref="status" :key="st.text" :id="`status` + index" color="transparent" :style="{ width: statusWidth + 'px', cursor: canBeClicked(st)?'pointer':'default' }" @click.native="click(st)">
        <v-icon left :color="!st.value ? `default` : `amber`">{{ st.value ? "mdi-led-on" : "mdi-led-off" }}</v-icon>
        {{ st.text }}
      </v-chip>
    </v-row>
  </v-card>
</template>

<script>
import Const from "../constants";
import Tremol from "../assets/fp/fp";
export default {
  data() {
    return {
      dialogReport: false,
      status: [],
      statusMessage: "",
      statusWidth: 355,
      statusSelected: null
    };
  },
  methods: {
    close() {
      this.fp.exitMode(Const.Modes.Status);
    },
    async click(st) {
      if (this.canBeClicked(st)) {
        this.statusSelected = st;
        this.dialogReport = true;
      }
    },
    async printReport() {
      this.fp.executeWithLoader(async () => {
        try {
          switch (this.statusSelected.text) {
            case Const.Statuses.Article_report_is_not_zeroed:
              await this.fp.PrintArticleReport(Tremol.Enums.OptionZeroing.Zeroing);
              break;

            case Const.Statuses.Daily_report_is_not_zeroed:
              await this.fp.PrintDailyReport(Tremol.Enums.OptionZeroing.Zeroing);
              break;

            case Const.Statuses.Operator_report_is_not_zeroed:
              await this.fp.PrintOperatorReport(Tremol.Enums.OptionZeroing.Zeroing, 0);
              break;

            case Const.Statuses.Customer_report_is_not_zeroed:
              await this.fp.PrintCustomerReport(Tremol.Enums.OptionZeroing.Zeroing);
              break;

            default:
              break;
          }
          await this.readStatus();
        } catch (ex) {
          this.fp.handleException(ex);
        }
      }, "Отпечатване на отчета...");
    },
    canBeClicked(st) {
      return st.value && (st.text == Const.Statuses.Article_report_is_not_zeroed || st.text == Const.Statuses.Operator_report_is_not_zeroed || st.text == Const.Statuses.Daily_report_is_not_zeroed || st.text == Const.Statuses.Customer_report_is_not_zeroed);
    },
    async readStatus() {
      try {
        this.status = [];
        var st = await this.fp.ReadStatus();
        this.fp.getStatusMessage(st);
        Object.keys(Const.Statuses).forEach(k => {
          var s = Const.Statuses[k];
          if (s) this.status.push({ name: k, text: s, value: st[k] });
        });
        this.statusMessage = this.fp.getErrorMessage();
      } catch (ex) {
        this.fp.handleException(ex);
      }
    }
  },
  mounted() {
    this.readStatus();
  },
  destroyed() {}
};
</script>

<style scoped></style>
